<template>
    <div
        class="o-wave"
        v-view="animate"
    >
        <div class="o-wave__inner" ref="wave">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1440 45">
                <path d="M0,16.13C72.89,5.99,211.71-6.76,329,4.23c64.57,6.05,109.38,12.24,147.64,17.53C535.54,29.9,578.91,35.9,655,35.9c55.75,0,122.93-6.25,197.62-13.2c93.46-8.69,198.66-18.48,307.88-18.48c131.67,0,230.21,14.81,279.5,25.83V45H0V16.13z"></path>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Wave',
    methods: {
        animate(e) {
            const scaleY = (1 - e.percentTop) * 1.25;
            const scaleX = (2 - (1 - e.percentTop));
            TweenLite.to(this.$refs.wave, 0.1, {
                scaleX,
                scaleY,
            });
        },
    },
};
</script>

<style lang="scss" scoped>

    .o-wave {
        width: 100%;
        overflow: hidden;
    }

    .o-wave__inner {
        width: 100%;
        height: 0;
        padding-top: $wave-height;
        transform-origin: 0% 100%;

        &:after {
            @include pseudo-el($height: 5vh, $bg: $color-light);
            position: absolute;
            top: 100%;
            left: 0;
        }

        svg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            fill: $color-light;
//            filter: drop-shadow(0 -20px 20px rgba(0, 0, 0, .03));
//
//            .is-safari & { filter: none }
        }
    }

</style>
